import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";

import VisionBanner from "../../assets/Vision.png";
import PageTitle from "../../Components/PageTitle";

const Vision = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Vision - Shree Mangalam School"
        description="At Shree Mangalam School, our vision is to empower students with discipline, knowledge, and leadership to excel in competitive exams like RIMC, Sainik School, and Military School."
        url="/vision"
        keywords="school vision, Shree Manglam vision, RIMC goal, sainik school mission, student development vision, leadership and discipline"
      />

      <Header image={VisionBanner} alt={"Vision"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Vision
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, our vision is to nurture
          individuals who are not only academically proficient but also
          emotionally intelligent, ethically grounded, and socially responsible.
          We believe that education is the most powerful tool to unlock a
          child's true potential and shape a brighter, more inclusive future.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our goal is to create a transformative learning environment rooted in
          Indian values and global perspectives, where students are inspired to
          think critically, act with compassion, and strive for excellence. We
          aim to cultivate individuals who respect the diversity of our nation,
          uphold constitutional values, and are prepared to take on the
          challenges of a rapidly changing world.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We envision our students growing into engaged citizens — equipped with
          the knowledge, skills, and moral compass necessary to lead with
          integrity, contribute meaningfully to society, and uphold the spirit
          of “Unity in Diversity.”
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          With a strong emphasis on holistic development, our curriculum
          integrates academic rigor with co-curricular engagement, ethical
          learning, and a sense of service. We are committed to producing
          lifelong learners, visionary leaders, and global citizens who are
          proud of their identity and committed to building a just, sustainable,
          and prosperous India.
        </Typography>
      </Container>

      <Footer />
    </>
  );
};

export default Vision;
